<template>
	<v-container fluid>
    <v-row>
      <v-text-field
          v-model="questionText"
          clearable
          prepend-inner-icon="mdi-magnify"
      />
    </v-row>
		<v-row>
			<v-col>
				<v-data-table
					:headers="headers"
					:items="questions"
					:items-per-page="20"
					:footer-props="footerProps"
					class="elevation-1"
				>
					<template #top>
						<p class="mr-4">
							{{$t('pages.createGame.left')}} : {{ questions.length }}
						</p>
					</template>
					<template v-slot:item.add="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									small
									fab
									v-bind="attrs"
									dark
									color="main_pink"
									v-on="on"
									@click="addQuestion(item)"
								>
									<v-icon>
                    add
									</v-icon>
								</v-btn>
							</template>
							<span>{{$t('pages.createGame.addQuestion')}}</span>
						</v-tooltip>
					</template>
					<template v-slot:item.question_type="{ item }">
						<type-display :type="item" />
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { types } from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";
import TypeDisplay from "../../components/TypeDisplay";

export default {
	name: "QuestionsPool",
	components: { TypeDisplay },
	props: { selectedQuestions: Array },
	data () {
		return {
			questionText: "",
			currentPage: 1,
			headers: [
        {
          text: this.$t("pages.createGame.questionContent"),
          align: "right",
          sortable: false,
          value: "question",
        },
				{ text: this.$t("pages.createGame.questionType"), value: "question_type" },

				{ text: this.$t("pages.createGame.correctAnswer"), value: "answer.content" },
				{ text: "", align: "left", value: "add" }
			],
			footerProps: { "items-per-page-options": [10, 20, 50, 100] },
		};
	},
	computed: {
		game () {
			return this.$store.state.GameModule.game;
		},
		questions () {
			//return this.$store.state.QuestionModule.questions;
			//	if (!this.game.type) return [];
			return (
				this.$store.state.QuestionModule.questions
					/* filter by search text */
					.filter((question) => {
						return (
							question.question.includes(this.questionText || "") ||
							question.tags.some((tag) =>
								tag.name.includes(this.questionText || "")
							)
						);
					})
					/* filter questiont Not chosen to this game */
					.filter((q) => !this.selectedQuestionsId.includes(q.id))
					/* filter by game type */
					// .filter((q) => {
					// 	return q.relevantTypes.includes(this.game.type.id);
					// })
			);
		},
		selectedQuestionsId () {
			return this.selectedQuestions.map((q) => q.id);
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
	},
	methods: {
		async addQuestion (question) {
			this.$emit("add", question);
		}
	},
};
</script>

<style scoped lang="scss">
.questions-toolbar{
  background-image: linear-gradient(to right, #E77B2D , #DA2570);
}
</style>
